import { type CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { md } = constants.breakpoints.BreakpointNames;

export const folderContentsWrapper: CSSObject = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

export const folderContentsHeader = (
  isTeacherChallengePage: boolean = false,
): CSSObject => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",

  [mq.downTo(md)]: {
    flexDirection: isTeacherChallengePage ? "row" : "column",
  },
});
